module.exports = __webpack_public_path__ + "06_mid_black.37b795cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/06_mid_black.png
// module id = TQrn
// module chunks = 0